var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUnit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.459,
    height: 58.46,
    viewBox: "0 0 58.459 58.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Best_deal",
    "data-name": "Best deal",
    transform: "translate(-383.96 -588.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M407.433,647.085a7.3,7.3,0,0,1-5.2-2.155l-16.118-16.12a7.349,7.349,0,0,1-.141-10.249l25.981-26.932a9.647,9.647,0,0,1,6.994-3h16.121a7.36,7.36,0,0,1,7.351,7.353V612.1a9.694,9.694,0,0,1-3.015,7.01l-26.9,25.949A7.351,7.351,0,0,1,407.433,647.085Zm11.514-55.271a6.463,6.463,0,0,0-4.686,2.015l-25.984,26.934a4.162,4.162,0,0,0,.09,5.791l16.119,16.122a4.166,4.166,0,0,0,5.814.075L437.2,616.8a6.5,6.5,0,0,0,2.03-4.7v-16.12a4.169,4.169,0,0,0-4.163-4.164Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M425.993,611.636a6.466,6.466,0,1,1,6.467-6.466A6.474,6.474,0,0,1,425.993,611.636Zm0-10.433a3.966,3.966,0,1,0,3.967,3.967A3.97,3.97,0,0,0,425.993,601.2Z",
    fill: "#666"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnit);
export default __webpack_public_path__ + "static/media/ic_unit.4ce30645.svg";
export { ForwardRef as ReactComponent };